/** LSP-19521: the stand-in `uploadId` a deferred row carries until its first server target is attached. */
export const PENDING_UPLOAD_TARGET_PREFIX = "pending-target:";

/**
 * LSP-23105: true when `uploadId` is `sessionId`'s own placeholder. Session ids are minted per pick, so this
 * value can only describe that row before its first target was attached — never a successor upload.
 */
export function isOwnPendingTargetPlaceholder(sessionId: string | undefined, uploadId: string | undefined): boolean {
	return Boolean(sessionId) && uploadId === `${PENDING_UPLOAD_TARGET_PREFIX}${sessionId}`;
}

/**
 * LSP-21977: the API addresses an upload by `registryId ?? uploadId`, so a row with no registry id and a
 * placeholder `uploadId` has no server upload to ask about — contact-api 404s that id before any controller
 * runs. A cancel checkpoint that recovered its registry id is NOT this: it still has a server attempt to abort.
 */
export function hasNoServerUploadTarget(session: { registryId?: string; uploadId: string }): boolean {
	return !session.registryId && typeof session.uploadId === "string" && session.uploadId.startsWith(PENDING_UPLOAD_TARGET_PREFIX);
}
